import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Checkout({ cartItems }) {
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    pincode: "",
    state: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // No need to fetch cart from backend if it's already passed as prop
  // But if you want live fetch, you can uncomment below
  // const [cartItems, setCartItems] = useState([]);
  // useEffect(() => {
  //   axios.get("http://localhost:8083/api/cart")
  //     .then(res => setCartItems(res.data))
  //     .catch(err => console.error(err));
  // }, []);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!user.name || !user.email || !user.phone ||
        !user.address || !user.pincode || !user.state) {
      alert("Please fill all required fields.");
      return;
    }

    setLoading(true);

    axios.post("http://localhost:8083/api/orders/create", { user, cartItems })
      .then(res => {
        console.log(res.data);
        setSubmitted(true);
      })
      .catch(err => {
        console.error(err);
        alert("Failed to submit order. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity, 0
  );

  if (submitted) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <h2>Order Confirmed!</h2>
        <p>
          Thank you, {user.name}.  
          A confirmation email has been sent to <b>{user.email}</b>.
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: "40px", padding: "40px" }}>
      {/* LEFT SIDE - USER FORM */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "15px" }}>
        <h2>Shipping Details</h2>

        <input type="text" name="name" value={user.name}
          onChange={handleChange} placeholder="Full Name"
          style={inputStyle} />

        <input type="email" name="email" value={user.email}
          onChange={handleChange} placeholder="Email"
          style={inputStyle} />

        <input type="text" name="phone" value={user.phone}
          onChange={handleChange} placeholder="Phone Number"
          style={inputStyle} />

        <textarea name="address" value={user.address}
          onChange={handleChange} placeholder="Shipping Address"
          style={{ ...inputStyle, minHeight: "60px" }} />

        <input type="text" name="pincode" value={user.pincode}
          onChange={handleChange} placeholder="Pincode"
          style={inputStyle} />

        <input type="text" name="state" value={user.state}
          onChange={handleChange} placeholder="State"
          style={inputStyle} />

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            padding: "12px",
            backgroundColor: loading ? "#777" : "#1b7a1b",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            marginTop: "10px"
          }}
        >
          {loading ? "Submitting..." : "Submit Order"}
        </button>
      </div>

      {/* RIGHT SIDE - ORDER SUMMARY */}
      <div style={{
        flex: 1,
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px"
      }}>
        <h2>Order Summary</h2>

        {cartItems.length === 0 ? (
          <p>Your cart is empty</p>
        ) : (
          cartItems.map(item => (
            <div key={item.id}
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "15px",
                alignItems: "center"
              }}>

              <img src={item.imageUrl} alt={item.name}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "6px"
                }} />

              <div>
                <div style={{ fontWeight: "bold" }}>{item.name}</div>
                <div>Quantity: {item.quantity}</div>
                <div>
                  ₹{item.price} × {item.quantity} = <b>₹{item.price * item.quantity}</b>
                </div>
              </div>
            </div>
          ))
        )}

        <hr />

        <div style={{ fontWeight: "bold", fontSize: "18px" }}>
          Subtotal: ₹{subtotal}
        </div>

        <div style={{ fontWeight: "bold", fontSize: "18px", marginTop: "10px" }}>
          Total: ₹{subtotal}
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  padding: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  width: "100%"
};
